import { Study, Patient } from '@radsource/ng-common-lib';
import { PatientInstance } from "./patient-instance";
import { SeriesInstance } from "./series-instance";
import { of } from "rxjs";
import { CMoveProgress } from "./cmove-progress";
import { Injectable } from '@angular/core';

@Injectable()
export class StudyInstance extends Study {

    //PROPERTIES
    modalities: string[];
    new_study_instance_uid: string;
    number_of_study_related_instances: number;
    number_of_study_related_series: number;

    //related instance objects
    patient: PatientInstance;
    series: Array<SeriesInstance>;
    series$: any;

    //ui variables
    editTemplate: Boolean = false;
    editing: Boolean = false;
    saving: Boolean = false;
    expanded: Boolean = false;
	expanded$: any;
    transferring: Boolean = false;
    transferring$: any;
    pushing: Boolean = false;
    pushing$: any;
    pushAttempted: Boolean = false;
    pushAttempted$: any;
    canceled: Boolean = false;
    canceled$: any;
    canceling: Boolean = false;
    canceling$: any;
    percentagePushed: number = 0;
    percentagePushed$: any;

    //postPush ui variables
    kept: Boolean = false;
    
    pushProgress: CMoveProgress = new CMoveProgress();
    pushProgress$: any;
    
    //CONSTRUCTOR
    constructor();
    constructor(
        instance: any
    );
    constructor(instance?: any) {
        super(instance);
        // this.misc = (instance && instance.misc) ? instance.misc : null;
        this.modalities = (instance && instance.modalities) ? instance.modalities : null;
        this.new_study_instance_uid = (instance && instance.new_study_instance_uid) ? instance.new_study_instance_uid : null;
        this.number_of_study_related_instances = (instance && instance.number_of_study_related_instances) ? instance.number_of_study_related_instances : 0;
        this.number_of_study_related_series = (instance && instance.number_of_study_related_series) ? instance.number_of_study_related_series : 0;
        this.expanded$ = of(this.expanded);

        //pushProgress init
        this.pushProgress$ = of(this.pushProgress);
        
        //related instance objects
        this.patient = (instance && instance.patient) ? new PatientInstance(instance.patient) : new PatientInstance();
        this.series = (instance && instance.series) ? instance.series : new Array<SeriesInstance>();
        this.series$ = of(this.series);
    } //end constructor

	resetAllButThumbnail(): void {
		this.pushAttempted = false;
		this.editing = false;
		this.saving = false;
		this.pushing = false;
		this.transferring = false;
		this.canceled = false;
		this.expanded = false; 
        this.kept = false;
        this.pushProgress = new CMoveProgress();
        this.pushProgress$ = of(this.pushProgress);
        
		this.pushAttempted$ = of(this.pushAttempted);
		this.pushing$ = of(this.pushing);
		this.transferring$ = of(this.transferring);
		this.canceled$ = of(this.canceled);
		this.expanded$ = of(this.expanded);
	}

    update(inst: StudyInstance): void {
        this.accession_number = inst.accession_number;
        this.date = inst.date;
        this.description = inst.description;
        this.id = inst.id;
        this.instance_uid = inst.instance_uid;
        // this.misc = inst.misc;
        this.modalities = inst.modalities;
        this.new_study_instance_uid = inst.new_study_instance_uid;
        this.number_of_study_related_instances = inst.number_of_study_related_instances;
        this.number_of_study_related_series = inst.number_of_study_related_series;
        this.patient_record_id = inst.patient_record_id;
        this.record_id = inst.record_id;
        this.referring_physician = inst.referring_physician;
    }

    updateProgress(data: any): any {

        if (data.constructor.name == 'CMoveProgress') {
            this.pushProgress = new CMoveProgress(data);
        } else if (data.constructor.name == 'CMoveRequest') {
            this.pushProgress.complete = data.sops_complete;
            this.pushProgress.failed = data.sops_failed;
            this.pushProgress.canceled = data.sops_canceled;
            this.pushProgress.warned = data.sops_warning;
            this.pushProgress.remaining = data.sops_remaining;
            this.pushProgress.request_id = data.request_id;
            this.pushProgress.state = data.state;
            this.pushProgress.user = data.owner;
            this.pushProgress.wado_patient_record_id = data.wado_patient_record_id;
            this.pushProgress.wado_study_record_id = data.wado_study_record_id;
        } else {
            if (data && data.sops_complete != null) { this.pushProgress.complete = data.sops_complete; } else if (data && data.complete != null) { this.pushProgress.complete = data.complete; }
            if (data && data.sops_failed != null) { this.pushProgress.failed = data.sops_failed; } else if (data && data.failed != null) { this.pushProgress.failed = data.failed; }
            if (data && data.sops_canceled != null) { this.pushProgress.canceled = data.sops_canceled; } else if (data && data.canceled != null) { this.pushProgress.canceled = data.canceled; }
            if (data && data.sops_warning != null) { this.pushProgress.warned = data.sops_warning; } else if (data && data.warning != null) { this.pushProgress.warned = data.warning; }
            if (data && data.sops_remaining != null) { this.pushProgress.remaining = data.sops_remaining; } else if (data && data.remaining != null) { this.pushProgress.remaining = data.remaining; }
            if (data && data.request_id) { this.pushProgress.request_id = data.request_id; }
            if (data && data.state) { this.pushProgress.state = data.state; }
            if (data && data.owner) { this.pushProgress.user = data.owner; }
            if (data && data.wado_patient_record_id) { this.pushProgress.wado_patient_record_id = data.wado_patient_record_id; }
            if (data && data.wado_study_record_id) { this.pushProgress.wado_study_record_id = data.wado_study_record_id; }
        }

        this.pushProgress$ = of(this.pushProgress);
        this.percentagePushed = Math.round( ( this.pushProgress.complete + this.pushProgress.failed + this.pushProgress.canceled + this.pushProgress.warned ) / ( this.pushProgress.remaining + this.pushProgress.complete + this.pushProgress.failed + this.pushProgress.canceled + this.pushProgress.warned ) * 100);
        this.percentagePushed$ = of(this.percentagePushed);

        this.pushing = true;
        this.pushing$ = of(this.pushing);

        if ( this.canceling == true || this.canceled == true ) {
            return;
        }

        if (this.pushProgress.remaining == 0) {
			this.pushAttempted = true;
            this.pushAttempted$ = of(this.pushAttempted);
            this.transferring = false;
            this.transferring$ = of(this.transferring);
		} else {
            this.transferring = true;
            this.transferring$ = of(this.transferring);
        }
    }
    
    essentials(): any {
        let essentials = {
            accession_number: this.accession_number,
            date: this.date,
            description: this.description,
            id: this.id,
            instance_uid: this.instance_uid,
            // misc: this.misc
            modalities: this.modalities,
            new_study_instance_uid: this.new_study_instance_uid,
            number_of_study_related_instances: this.number_of_study_related_instances,
            number_of_study_related_series: this.number_of_study_related_series,
            patient_record_id: this.patient_record_id,
            record_id: this.record_id,
            referring_physician: this.referring_physician,
        }
        return essentials;
    }
} //end class